// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GhN-","right":"styles_right__2ihz5"};